import apiEndpoints from 'api/endpoints';

import { baseAPI } from './baseApi';

export const homePageApi = baseAPI.injectEndpoints({
    endpoints: (builder) => ({
        getGraphStatistics: builder.query({
            query: ({ filter_type, start_date, end_date }) => {
                let baseUrl = `${apiEndpoints.graphStatistics}?filter_type=${filter_type}`;

                if (filter_type === 'CUSTOM' && start_date && end_date) {
                    baseUrl += `&start_date=${start_date}&end_date=${end_date}`;
                }

                return {
                    url: baseUrl,
                    method: 'GET',
                };
            },
        }),
    }),
});

export const { useGetGraphStatisticsQuery } = homePageApi;

export default homePageApi.middleware;
